import { h, defineComponent } from 'vue';
import { PortalCallbacks, portalSection } from '@/services/chargebee/types';
import { t } from '@/ui/i18n/i18n';
import { box, button, pageSubtitle } from '@/ui/components';

export const BillingAddress = defineComponent({
  name: 'BillingAddress',
  setup(props, context) {
    const callbacks: PortalCallbacks = {
      loaded: () => {

      },
      close: () => {

      },
      visit: (sectionType: string) => {
        // use for mixpanel and ga events
      },
    };

    const showBillingAddress = () => context.emit('click', {
      sectionType: portalSection.ADDRESS,
      callbacks,
    });

    return function render() {
      return box([
        pageSubtitle(t('subscription.billing-address')),
        h('p', { class: 'description' }, t('subscription.billing-info')),
        button(t('common.edit'), showBillingAddress),
      ]);
    };
  },
});
